import { Dialog, Button } from '@workspace/design-system/src/components';

interface PaymentRequestConfirmDialogProps {
    channelName: string;
    paymentMethod: 'TOSS_PG' | 'DIRECT';
    onClose: () => void;
    onConfirm: () => void;
}

export function PaymentRequestConfirmDialog({
    channelName,
    paymentMethod,
    onClose,
    onConfirm
}: PaymentRequestConfirmDialogProps) {
    const isDirectPayment = paymentMethod === 'DIRECT';

    return (
        <Dialog>
            <Dialog.Content className="max-w-[480px]">
                <Dialog.Header
                    title="결제를 요청하시겠습니까?"
                    type="question"
                    showIcon
                />

                <Dialog.Body>
                    <div className="flex flex-col gap-2">
                    </div>
                </Dialog.Body>

                <Dialog.Footer className="flex gap-3 items-center justify-end">
                    <Button
                        styleType="basic"
                        styleSize="M-40"
                        onClick={onClose}
                    >
                        취소
                    </Button>
                    <Button
                        styleType="primary"
                        styleSize="M-40"
                        onClick={onConfirm}
                    >
                        확인
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}

